<mat-list
  ><mat-list-item *ngFor="let item of data">
    <h4 mat-line class="text-no-overflow">
      <b>{{ stripHtml(item.question) }}</b>
    </h4>
    <p mat-line class="text-no-overflow">
      <small>
        {{ stripHtml(item.answer) }}
      </small>
    </p>
  </mat-list-item></mat-list
>
